export const SettingAccountTab = "account"
export const SettingLanguageRegionTab = "language-region"
export const SettingPersonalizationTab = "personalization"
export const SettingNotificationsTab = "notifications"
export const SettingEarlyAccessTab = "early-access"
export const SettingPaymentTab = "payment"
export const SettingRewardProgramsTab = "reward-programs"
export const SettingTravelersTab = "travelers"
export const SettingCookiePreferencesTab = "cookie-preferences"
export const SettingConnectedAccountsTab = "connected-accounts"
export const SettingConnectedCalPreviewTab = "connected-cal-preview"
export const SettingGmailPreviewTab = "gmail-preview"
export const SettingProactiveAgentsTab = "price-alerts"
export const SettingAgentCliTab = "agent-cli"

export type SettingTabType =
  | typeof SettingAccountTab
  | typeof SettingLanguageRegionTab
  | typeof SettingPersonalizationTab
  | typeof SettingNotificationsTab
  | typeof SettingEarlyAccessTab
  | typeof SettingPaymentTab
  | typeof SettingRewardProgramsTab
  | typeof SettingTravelersTab
  | typeof SettingCookiePreferencesTab
  | typeof SettingConnectedAccountsTab
  | typeof SettingConnectedCalPreviewTab
  | typeof SettingGmailPreviewTab
  | typeof SettingProactiveAgentsTab
  | typeof SettingAgentCliTab

export const SettingTabTypeValues: SettingTabType[] = [
  SettingAccountTab,
  SettingLanguageRegionTab,
  SettingPersonalizationTab,
  SettingNotificationsTab,
  SettingEarlyAccessTab,
  SettingPaymentTab,
  SettingRewardProgramsTab,
  SettingTravelersTab,
  SettingConnectedAccountsTab,
  SettingConnectedCalPreviewTab,
  SettingGmailPreviewTab,
  SettingCookiePreferencesTab,
  SettingProactiveAgentsTab,
  SettingAgentCliTab,
] as const
